import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/styles'
import SendIcon from '@material-ui/icons/Send'
import IconButton from '@material-ui/core/IconButton'
import { returnToMenu } from '../actions/digitalMenuActions'
import { useDispatch } from 'react-redux'

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    textAlign: 'center'
  },
  cssLabel: {
    color: '#FFFFFF',
    fontColor: '#FFFFFF',
    borderColor: '#FFFFFF !important'
  },

  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      color: '#FFFFFF',
      fontColor: '#FFFFFF',
      borderColor: '#FFFFFF !important'
    }
  },

  cssFocused: {
    color: '#FFFFFF',
    fontColor: '#FFFFFF',
    borderColor: '#FFFFFF !important'
  },

  notchedOutline: {
    color: '#FFFFFF',
    fontColor: '#FFFFFF',
    borderWidth: '1px',
    borderColor: '#FFFFFF !important'
  },
}))

const StoreSelector = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [storeCode, setStoreCode] = useState('')

  const handleSendStoreCode = () => {
    dispatch(returnToMenu(storeCode))
  }

  return <Grid
    className={classes.container}
    container
    justify="center"
    direction="row"
    alignContent="center"
    alignItems="center"
  >
    <Grid item xs={8}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <h3>Digite o código da Loja abaixo, ou acesse o site via QR Code</h3>
        </Grid>
        <Grid item xs={12}>
          <form noValidate onSubmit={handleSendStoreCode}>
            <Grid container spacing={0} alignContent="center" alignItems="center" justify="center">
              <Grid item xs={11}>
                <TextField
                  value={storeCode}
                  onChange={e => setStoreCode(e.target.value.toLowerCase())}
                  InputLabelProps={{
                    style: {
                      color: '#FFFFFF',
                      fontColor: '#FFFFFF',
                      borderColor: '#FFFFFF !important'
                    },
                    classes: {
                      root: classes.cssLabel,
                      focused: classes.cssFocused,
                    },
                  }}
                  InputProps={{
                    style: {
                      color: '#FFFFFF',
                      fontColor: '#FFFFFF',
                      borderColor: '#FFFFFF !important'
                    },
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                    inputMode: 'numeric'
                  }}
                  id="outlined-basic"
                  label="Código"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  onClick={handleSendStoreCode}
                  className={classes.arrowButton}
                >
                  <SendIcon
                    style={{ fill: '#FFFFFF' }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
}

export default StoreSelector
